<template>
  <div class="list">
    <div class="header">
      <div class="l">
        <div class="label">
          所属机构
        </div>
        <el-select
          v-model="searchForm.agencyId"
          placeholder="请选择所属机构"
          filterable
          clearable
          @change="getList()"
        >
          <el-option
            v-for="item in agencyList"
            :key="item.id"
            :label="item.value"
            :value="item.id"
          />
        </el-select>
        <div class="label">
          审核状态
        </div>
        <el-select
          v-model="searchForm.examStatus"
          placeholder="请选择审核状态"
          filterable
          clearable
          @change="getList()"
        >
          <el-option
            v-for="item in examVideoStatusList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
    </div>
    <data-table
      :data="tabelData"
      :pagination="true"
      :table-column="tableColumn"
      @changeBypagination="tableHandle"
      @sortChange="sortChange"
      @buttonClick="buttonClick"
    />
    <video-dialog
      :dialog-visible.sync="vedioVisible"
      :item="activeVideoItem"
    />
  </div>
</template>

<script>
import axClient from '@/services';
import dataTable from '@/components/common/dataTable.vue';
import { examVideoStatusList, courseTypeList } from '@/config';
import videoDialog from '@/components/common/videoDialog.vue';

export default {
  name: 'Home',
  components: {
    dataTable,
    videoDialog,
  },
  data() {
    return {
      vedioVisible: false,
      activeVideoItem: {},
      examVideoStatusList,
      agencyList: [],
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        agencyId: '',
        examStatus: '',
      },
      tabelData: {},
      tableColumn: [
        {
          key: 'userRealName',
          label: '学员姓名',
          width: '120px',
          dataType: 'text',
        },
        {
          key: 'agencyName',
          label: '所属名称',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'courseName',
          label: '课程名称',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'courseType',
          label: '课程类型',
          width: '80px',
          dataType: 'function',
          renderProps: '',
          render: (key) => courseTypeList.filter((item) => item.value === key),
        },
        {
          key: 'chapterName',
          label: '章节名称',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'auditUserName',
          label: '审核人',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'examScore',
          label: '分数',
          width: 'auto',
          dataType: 'money',
        },
        {
          key: 'auditAmount',
          label: '审核金额',
          width: 'auto',
          dataType: 'money',
        },
        {
          key: 'auditAmountIsExtract',
          label: '是否提取',
          width: 'auto',
          dataType: 'component',
          renderProps: { 0: '未提取', 1: '已提取', successKey: 0 },
          render: () => 'status',
        },
        {
          key: 'auditTime',
          label: '审核时间',
          width: 'auto',
          dataType: 'time',
        },
        {
          key: 'examStatus',
          label: '审核状态',
          width: 'auto',
          dataType: 'function',
          renderProps: '',
          render: (key) => examVideoStatusList.filter((item) => item.value === key),
        },
        {
          key: 'control',
          label: '操作',
          width: '100px',
          dataType: 'component',
          renderProps: [
            {
              text: '播放视频', renderKey: null, type: 'info', eventIndex: 0, disableKey: null,
            },
          ],
          render: () => 'buttons',
        },
      ],
    };
  },
  mounted() {
    this.getList();
    this.selectList();
  },
  methods: {
    // 获取列表
    async getList(num = 1) {
      this.searchForm.pageNum = num;
      const result = await axClient.registration.pageVideoExamRecordBackend(this.searchForm);
      const { pageNum, pageSize, total } = result;
      this.tabelData = {
        pageNum,
        pageSize,
        total,
        list: result.list,
      };
    },
    async selectList() {
      const all = {
        id: '',
        value: '全部',
      };
      this.agencyList = await axClient.registration.listNameByRegistration();
      this.agencyList = [all, ...this.agencyList];
      this.examVideoStatusList = [{ label: '全部', value: '' }, ...this.examVideoStatusList];
    },
    // table 改变 pagination 时间
    tableHandle(pageNum, pageSize) {
      this.searchForm.pageNum = pageNum;
      this.searchForm.pageSize = pageSize;
      this.getList(pageNum);
    },
    // table sortChange
    sortChange(data) {
      const { prop, order } = data;
      const sortType = {
        createTime: {
          ascending: 10,
          descending: 20,
        },
      };
      this.searchForm.sortType = sortType[prop][order];
      this.getList();
    },
    // table 传递过来的按钮点击
    buttonClick(type, item) {
      switch (type) {
        case 0:
          this.openVideoDialog(item);
          break;
        default:
          break;
      }
    },
    openVideoDialog(item) {
      this.vedioVisible = true;
      this.activeVideoItem.url = item.videoUrl;
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
